module.exports = __webpack_public_path__ + "61413b3faef6cab56f8e44775512451d.svg";